/**
 * Maps due-date urgency state to a Stencil text color token.
 *
 * Reusable across any component that displays a due date with
 * urgency/overdue visual feedback (cards, list items, detail pages).
 *
 * @param isOverdue  - true if the item is past its due date
 * @param isUrgent   - true if the item is approaching its due date
 * @returns Stencil color token string
 */
export function getDueDateColor(isOverdue: boolean, isUrgent: boolean): string {
  // `-icon` variants are the standard critical/warning colors — the
  // design token set has NO `critical-text` / `warning-text` tokens.
  // Stencil's Text resolves unknown token paths to undefined and
  // silently renders the default text color, so the phantom names
  // made overdue/urgent dates black instead of red/orange.
  if (isOverdue) return 'color.status.critical-icon';
  if (isUrgent) return 'color.status.warning-icon';
  return 'color.text.secondary';
}
